import type { ReactNode } from "react";
import type { Icon } from "@phosphor-icons/react";
import styles from "./Banner.module.css";

type Variant = "danger" | "warning" | "info" | "success";

type Props = {
  variant?: Variant;
  icon: Icon;
  title: ReactNode;
  children?: ReactNode;
};

export function Banner({ variant = "info", icon: Icon, title, children }: Props) {
  return (
    <div className={`${styles.banner} ${styles[variant]}`} role="status">
      <span className={styles.iconWrap}>
        <Icon size={24} weight="regular" />
      </span>
      <div className={styles.body}>
        <span className={styles.title}>{title}</span>
        {children && <span className={styles.subtitle}>{children}</span>}
      </div>
    </div>
  );
}
